import Vue from 'vue'
import store from '../store/store.js'
import router from '../router/index'

export function getClientType() {
  let UA = navigator.userAgent
  if (/(iPhone|iPad|iPod|iOS)/i.test(UA)) {
    return 'ios'
  } else if (/Android/.test(UA)) {
    return 'android'
  } else if (/Windows/.test(UA)) {
    return 'pc'
  } else {
    return 'mac'
  }
}

export const isWechat = () => {
  return !!/MicroMessenger/i.test(navigator.userAgent)
}

export async function startClient(order) {
  if (!Object.keys(order).length) {
    this.$toast('订单信息有误,请重试!')
  }
  store.commit('setOrder', order)
  store.commit('setOrderCheck', new Date())
  let { uuid, gameId } = order

  if (!uuid) {
    Vue.prototype.$toast('启动失败，请重试。')
    return
  }
  let cmd = `--uuid ${uuid}`
  if (gameId) {

    let res = await Vue.prototype.$http.get_game({ id: gameId })
    let { gameAlias } = res.data
    cmd += ` --gamename ${gameAlias}`
  }
  cmd +=` --fps ${order.orderComputer.fps} --httpsPort ${order.orderComputer.httpsPort} --resolution ${order.orderComputer.resolution} --wanIp ${order.orderComputer.wanIp}`
  var loading = Vue.prototype.$loading({
    lock: true,
    text: '准备启动游戏中......',
    spinner: 'el-icon-loading',
    background: 'rgba(0, 0, 0, 0.7)',
  })

  setTimeout(() => {
    try {
      // eslint-disable-next-line
      window.bridge.startGame(cmd, function(message) { 
        setTimeout(function() {
          loading.close()
        }, 3000)
        if (message != '') {
          Vue.prototype.$toast(message)
          router.push('/games')
        } else {
          store.commit('setOnPkView', true)
        }
      })
    } catch (e) {
      loading.close()
      Vue.prototype.$toast('连接时出现错误,请重新连接。')
    }
  }, 500)
}

export function parseUrl(url) {
  if (!url) return {}
  if (url.split('?').length <= 1) return {}
  let queryUrl = url.split('?')[1]
  let queryArr = queryUrl.split('&')
  let queryObj = {}
  queryArr.forEach(item => {
    let key = item.split('=')[0]
    let value = item.split('=')[1]
    queryObj[key] = value
  })
  return queryObj
}
 
// 1024;KB
// 1024*1024=1048576;MB
// 1024*1024*1024=1073741824;GB
// 1024*1024*1024*1024=1099511627776;TB
export function unitConversion(num, fix) {
  if (num < 0 || num === undefined) {
    return '--'
  } else if (num < 1024) {
    return num + ' B'
  } else if (num >= 1024 && num < 1048576) {
    return (num / 1024).toFixed(fix) + ' KB'
  } else if (num >= 1048576 && num < 1073741824) {
    return (num / 1048576).toFixed(fix) + ' MB'
  } else if (num >= 1073741824 && num < 1099511627776) {
    return (num / 1073741824).toFixed(fix) + ' GB'
  } else if (num >= 1099511627776) {
    return (num / 1099511627776).toFixed(fix) + ' TB'
  }
}

// 复制文字
export function copyContext(text) {
  const oInput = document.createElement('input')
  oInput.value = text
  document.body.appendChild(oInput)
  oInput.select()
  document.execCommand('Copy')
  document.body.removeChild(oInput)
}

export function sleep(ms) {
  return new Promise(resolve => setTimeout(resolve, ms))
}

export function openInBrowser(url) {
  if (!url) return
  let platform = Vue.prototype._platform
  if (platform === 'qt') {
    if (!window.bridge) return
    window.bridge.downloadClientVersion(url, function(message) {})
  } else {
    window.open(url, '_blank')
  }
}
